export interface DataSourceContentCounts {
    tableCount?: number | null;
    uploadsCount?: number | null;
    fileCount?: number | null;
}

export interface DataSourceTypeChangeLocks {
    lockCategoryType: boolean;
    lockExternalProvider: boolean;
    disableInternalFileMode: boolean;
    disableInternalTableMode: boolean;
    categoryLockReason: string;
    externalProviderLockReason: string;
    internalFileModeLockReason: string;
    internalTableModeLockReason: string;
}

export const DATA_SOURCE_TYPE_CHANGE_I18N = {
    categoryLocked: 'The Internal or External type cannot be changed after the Data Source is created.',
    externalHasContent:
        'This Data Source contains tables. Remove all tables before changing the Data Source type.',
    externalHasFiles:
        'This Data Source contains files. Remove all files before changing the Data Source type.',
    internalHasTables:
        'This Data Source contains tables. Remove all tables before changing it to an unstructured Data Source.',
    internalHasFiles:
        'This Data Source contains files. Remove all files before changing it to a structured Data Source.',
} as const;

export function dataSourceHasTables(counts: DataSourceContentCounts): boolean {
    return (counts.tableCount ?? 0) > 0;
}

export function dataSourceHasFiles(counts: DataSourceContentCounts): boolean {
    return (counts.uploadsCount ?? 0) > 0 || (counts.fileCount ?? 0) > 0;
}

export function dataSourceTypeChangeLocks(opts: {
    dialogType?: string;
    sourceType?: string | null;
    counts: DataSourceContentCounts;
}): DataSourceTypeChangeLocks {
    const isEditOrView = opts.dialogType === 'Edit' || opts.dialogType === 'View';
    const hasTables = dataSourceHasTables(opts.counts);
    const hasFiles = dataSourceHasFiles(opts.counts);
    const isExternal = opts.sourceType === 'external';

    return {
        lockCategoryType: isEditOrView,
        lockExternalProvider: isEditOrView && isExternal && (hasTables || hasFiles),
        disableInternalFileMode: isEditOrView && hasTables,
        disableInternalTableMode: isEditOrView && hasFiles,
        categoryLockReason: DATA_SOURCE_TYPE_CHANGE_I18N.categoryLocked,
        externalProviderLockReason: hasFiles && !hasTables
            ? DATA_SOURCE_TYPE_CHANGE_I18N.externalHasFiles
            : DATA_SOURCE_TYPE_CHANGE_I18N.externalHasContent,
        internalFileModeLockReason: DATA_SOURCE_TYPE_CHANGE_I18N.internalHasTables,
        internalTableModeLockReason: DATA_SOURCE_TYPE_CHANGE_I18N.internalHasFiles,
    };
}
